<script setup lang="ts">
import { UnionColorKeys } from '@/types/global'
import { findColorValue } from '@/utils/style/'

const props = withDefaults(
  defineProps<{
    tag: 'a' | 'button' | 'router-link'
    color: UnionColorKeys
    isRound?: boolean
    isDisabled?: boolean
    borderColor?: UnionColorKeys | ''
    fontSize?: `${string}${'px'}`
    textColor?: UnionColorKeys | ''
  }>(),
  {
    isRound: false,
    isDisabled: false,
    borderColor: '',
    fontSize: '16px',
    textColor: '',
  }
)

const foundColorValue = findColorValue(props.color)
const defaultTextColor = findColorValue('white')
const styles: {
  backgroundColor: typeof foundColorValue
  border: string
  borderRadius: string
  color: string | undefined
} = {
  backgroundColor: foundColorValue,
  border: props.borderColor !== '' ? `1px solid ${findColorValue(props.borderColor)}` : '',
  borderRadius: props.isRound === true ? '24px' : '4px',
  color: props.textColor !== '' ? findColorValue(props.textColor) : defaultTextColor,
}
</script>

<template>
  <component :is="props.tag" :style="styles" class="btn" :disabled="props.isDisabled"><slot></slot></component>
</template>

<style lang="scss" scoped>
.btn {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: 48px;
  line-height: 48px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  font-size: v-bind(fontSize);
  box-shadow: 0 1px 6px #0000001f;
  outline: none;
  &:hover {
    opacity: unset;
  }
  &:disabled {
    cursor: inherit;
  }
}
</style>
